import { FC, PropsWithChildren } from 'react'
import { RouteContext } from './context'
import { useRouterValues } from './hooks'

export const RouterProvider: FC<PropsWithChildren> = ({ children }) => {
  const value = useRouterValues()

  return <RouteContext.Provider value={value}>{children}</RouteContext.Provider>
}
